import axios from "axios";
import { interceptor } from "./helper/middleware";

const privateApiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("user_access_token")}`,
  },
});

interceptor(privateApiClient);

export default privateApiClient;
